export function XIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" focusable="false" viewBox="0 0 16 16">
      <path stroke="currentColor" strokeLinecap="round" d="M3 13L13 3m0 10L3 3" />
    </svg>
  );
}
